import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100 d-flex flex-wrap" }
const _hoisted_2 = { class: "container-fluid px-xl-5" }
const _hoisted_3 = { class: "pt-5" }
const _hoisted_4 = { class: "row mt-4" }
const _hoisted_5 = { class: "col-6 form-inline d-flex justify-content-center" }
const _hoisted_6 = {
  class: "col-3 pr-2",
  for: "newAudio"
}
const _hoisted_7 = { class: "col-4" }
const _hoisted_8 = { class: "form-row d-flex justify-content-center" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = {
  type: "file",
  name: "file",
  placeholder: "Betawellen.mp3",
  class: "form-control",
  id: "vocabList",
  ref: "fileInput",
  accept: "audio/aiff, audio/flac, audio/mp4, audio/ogg, audio/mpeg, audio/vnd.wav"
}
const _hoisted_11 = { class: "col-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1)
const _hoisted_13 = { class: "py-5" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = { class: "list-group-item list-group-item-action align-items-center" }
const _hoisted_16 = { class: "col-4 justify-content-center align-items-center" }
const _hoisted_17 = {
  controls: "",
  ref: "audio",
  class: "w-100"
}
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "col-2 d-flex align-items-center" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_22 = { class: "row justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoContent = _resolveComponent("NoContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("messages.Add new superlearning music")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("messages.music name")), 1),
            _withDirectives(_createElementVNode("input", {
              class: "col-8 form-control",
              id: "newAudio",
              type: "text",
              placeholder: "Name der neuen Musik",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.newAudio.name = $event))
            }, null, 512), [
              [_vModelText, _ctx.newAudio.name]
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("input", _hoisted_10, null, 512)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createNew && _ctx.createNew(...args)))
            }, [
              _hoisted_12,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.Add to")), 1)
            ])
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_13, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t("messages.Existing learning music")), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.audios, (audio) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "row",
            key: audio.id
          }, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, _toDisplayString(audio.name), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("audio", _hoisted_17, [
                _createElementVNode("source", {
                  src: _ctx.serverUrl + audio.audioUrl,
                  type: "audio/mpeg"
                }, null, 8, _hoisted_18),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.no learn music")), 1)
              ], 512)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("button", {
                class: "btn btn-danger",
                onClick: ($event: any) => (_ctx.deleteAudio(audio.id))
              }, [
                _hoisted_21,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("messages.delete music")), 1)
              ], 8, _hoisted_20)
            ])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_22, [
          (!_ctx.audios.length)
            ? (_openBlock(), _createBlock(_component_NoContent, {
                key: 0,
                text: _ctx.$t('messages.no superlearning')
              }, null, 8, ["text"]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}